import { Text } from "@mantine/core";
import { useCsvContext } from "../context/CsvContext";

export const Footer = () => {
  const { csvData } = useCsvContext();

  const dataPoints = csvData[0]?.slice(1).length;

  return (
    <Text fw={900} mt="sm" size="sm" align="right">
      데이터 (부하점) 갯수: {dataPoints ?? "-"}
    </Text>
  );
};
